// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2Resr"};